/**
 * @generated SignedSource<<0bf144956ad6caf0587233192e1aeca5>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
type Labels_team$fragmentType = any;
import type { FragmentType } from "relay-runtime";
declare export opaque type Row_team$fragmentType: FragmentType;
export type Row_team$data = {|
  +description: ?string,
  +id: string,
  +members: ?{|
    +count: number,
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +user: ?{|
          +avatar: {|
            +url: string,
          |},
          +name: string,
        |},
      |},
    |}>,
  |},
  +name: string,
  +organization: ?{|
    +slug: string,
  |},
  +pipelines: ?{|
    +count: number,
  |},
  +slug: string,
  +suites: ?{|
    +count: number,
  |},
  +$fragmentSpreads: Labels_team$fragmentType,
  +$fragmentType: Row_team$fragmentType,
|};
export type Row_team$key = {
  +$data?: Row_team$data,
  +$fragmentSpreads: Row_team$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 4,
      "kind": "LocalArgument",
      "name": "maxAvatars"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Row_team",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Labels_team"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "maxAvatars"
        }
      ],
      "concreteType": "TeamMemberConnection",
      "kind": "LinkedField",
      "name": "members",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "TeamMemberEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TeamMember",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "user",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Avatar",
                      "kind": "LinkedField",
                      "name": "avatar",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "url",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamPipelineConnection",
      "kind": "LinkedField",
      "name": "pipelines",
      "plural": false,
      "selections": (v4/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamSuiteConnection",
      "kind": "LinkedField",
      "name": "suites",
      "plural": false,
      "selections": (v4/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};
})();

(node/*: any*/).hash = "5a15ac3ec40f334b2ef7897a87cf6d0b";

module.exports = ((node/*: any*/)/*: Fragment<
  Row_team$fragmentType,
  Row_team$data,
>*/);
